module.exports = __webpack_public_path__ + "static/18-b7cf9230f2416a232579beb9f8365e29.png";